
import { NoticeProps} from "@/scripts/datatypes"
import { Component,Mixins,Prop, Watch} from "vue-property-decorator"
import { ValidationObserver  } from 'vee-validate'
import Common from '@/mixins/common'
import {limit, onSnapshot, query, Unsubscribe, where} from 'firebase/firestore'
import { EventData, MemberMeta } from "@/common-datatypes"
import ModalSelectUser from '@/components/ModalSelectUser.vue'
import TemplateMembers from '@/components/TemplateMembers.vue'

@Component({
  components: {
    ModalSelectUser,
    TemplateMembers
  }
})

export default class EventListInMembers extends Mixins(Common) {
  @Prop({type: Array, default: () => {return []}}) private defaultUserIds?: string[]
  @Prop({type: Object, default: () => {return {}}}) private defaultUserMeta?: {}
  observers: (Unsubscribe | undefined)[] = []
  isModalSelectUserShow = false

  isLoading = false
  noticeProps = {} as NoticeProps

  memberUserIds: string[] = []
  memberMeta: {[key: string]: MemberMeta} = {}

  $refs!: {
    validationObserver: InstanceType<typeof ValidationObserver>;
  }

  observer: InstanceType<typeof ValidationObserver> | null = null

  eventsRawData: EventData[] = []

  selectedEventId = ''

  @Watch('memberUserIds')
  updateMemberUserIds(){
    this.getEventsQueryInMembers()
  }

  get userId(): string {
    return this.$store.getters.userId
  }

  isFuture(date: Date){
    return date.getTime() > new Date().getTime()
  }

  mounted(){
    console.log('mounted')
    this.observer = this.$refs.validationObserver
  }

  selectEvent(event: EventData){
    this.selectedEventId = event.id || ''
    this.$emit('onSelect',event)
  }

  async created(){
    console.trace('created')

    this.memberUserIds = this.defaultUserIds || []
    this.memberMeta = this.defaultUserMeta || {}

    this.$store.commit("setLoading",true)
    this.isLoading = true
    
    try{
      //
    }catch(error){
      console.log(error)
    }finally{
      this.$store.commit("setLoading",false);
      this.isLoading = false
    }
  }

  getEventsQueryInMembers(){
    this.$unsubscriber(this.observers)

    if(this.memberUserIds.length > 0){
      const eventsQuery = query(this.$getEventsColRef(),where('memberUserIds', 'array-contains-any', this.memberUserIds),limit(30))

      this.observers.push( onSnapshot(eventsQuery,(snapshot) => {
        snapshot.docs.forEach((doc) => {
          const row = doc.data()
          const findIndex = this.eventsRawData.findIndex((event) => {return event.id === doc.id})
          const deleteCount = (findIndex === -1 ? 0 : 1)
          this.eventsRawData.splice(findIndex,deleteCount,row)
        })
      }))
    }
  }

  get eventsData(){
    return this.eventsRawData.filter((event) => {
      return event.extendedProps.memberUserIds.some((userId) => {
        return this.memberUserIds.includes(userId)
      })
    }).sort((a,b) => {
      if(a.start && b.start){
        return b.start. getTime() - a.start.getTime()
      }
      return 0
    })
  }

  onConfirm(yes: boolean) {
    this.$emit("onConfirm", yes);
  }

  destroyed() {
    this.$unsubscriber(this.observers)
  }

}
